import { NotificationCard } from '../../components/Card';
import { MeetingContainer } from './MeetingContainer';
import { CalendarClose, CalendarPlus01 } from '@kula-ai/icons-core';

interface MeetingNotificationProps {
  notification?: Record<string, unknown>;
  onClose?: () => void;
}

export const MeetingCancelled = ({
  notification = {},
  onClose = () => {},
}: MeetingNotificationProps) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="cancelled"
        icon={CalendarClose}
        iconColor="#CD5C5C"
        iconbg="#FFE3E3"
      />
    </NotificationCard>
  );
};

export const MeetingBooked = ({
  notification = {},
  onClose = () => {},
}: MeetingNotificationProps) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="booked"
        icon={CalendarPlus01}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const CandidateMeetingBooked = ({
  notification = {},
  onClose = () => {},
}: MeetingNotificationProps) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="candidateBooked"
        icon={CalendarPlus01}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const MeetingStartingSoon = ({
  notification = {},
  onClose = () => {},
}: MeetingNotificationProps) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="startingSoon"
        icon={CalendarPlus01}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const MeetingReschedule = ({
  notification = {},
  onClose = () => {},
}: MeetingNotificationProps) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="reschedule"
        icon={CalendarPlus01}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={true}
      />
    </NotificationCard>
  );
};

export const RsvpReminder = ({
  notification = {},
  onClose = () => {},
}: MeetingNotificationProps) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="rsvpReminder"
        icon={CalendarPlus01}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={false}
      />
    </NotificationCard>
  );
};

export const RsvpReminderNotification = ({
  notification = {},
  onClose = () => {},
}: MeetingNotificationProps) => {
  return (
    <NotificationCard notification={notification}>
      <MeetingContainer
        notification={notification}
        onClose={onClose}
        type="rsvpReminderNotification"
        icon={CalendarPlus01}
        iconColor="#605AFB"
        iconbg="#F4F4FB"
        showButton={false}
      />
    </NotificationCard>
  );
};
